import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';

const NavigationTabsDocumentSettings: FC<NavigationTabsPropsHelper> = ({
    className,
    selection,
}) => {
    const {t} = useTranslation('Navigation.NavigationTabs');

    return (
        <BaseNavigationTabs className={className} selection={selection}>
            <BaseNavigationTabsButton
                href={window.Urls.preset_list_view()}
                label={t('documentSettings.documentPresets')}
                name="documentPresets"
            />
            <BaseNavigationTabsButton
                href={window.Urls.numbering_settings_view()}
                label={t('documentSettings.numbering')}
                name="numbering"
            />
            <BaseNavigationTabsButton
                href={window.Urls.approval_settings_view()}
                label={t('documentSettings.documentApproval')}
                name="documentApproval"
            />
            <BaseNavigationTabsButton
                href={window.Urls.partner_tags_view()}
                label={t('documentSettings.tags')}
                name="tags"
            />
            <BaseNavigationTabsButton
                href={`${window.Urls.customtemplate_list_view()}?filter_form=filter_all&state=notarchived`}
                label={t('documentSettings.customTemplates')}
                name="customTemplates"
            />
            <BaseNavigationTabsButton
                href={window.Urls.extendeddatafields_list_view()}
                label={t('documentSettings.extendedDataFields')}
                name="extendedDataFields"
            />
            <BaseNavigationTabsButton
                href={window.Urls.settings_document_conversion_view()}
                label={t('documentSettings.conversionSettings')}
                name="conversionSettings"
            />
            <BaseNavigationTabsButton
                href={window.Urls.react_tax_registration_number_view()}
                label={t('documentSettings.taxRegistrationNumber')}
                name="taxRegistrationNumber"
            />
            <BaseNavigationTabsButton
                href={window.Urls.pdf_filename_settings_view()}
                label={t('documentSettings.pdfFilenameSettings')}
                name="pdfFilenameSettings"
            />
        </BaseNavigationTabs>
    );
};

export default NavigationTabsDocumentSettings;
